import type { EquipItemType } from '@/types';
import { Box, Card, Group, Image, Text } from '@mantine/core';
import classes from './CharacterEquipCard.module.css';
export const CharacterEquipCard: React.FC<EquipItemType> = ({
  equipImg,
  part,
  rarity,
  rewards
}) => {
  return <Card radius={5} classNames={classes}>
      <Group gap="md">
        <Image src={equipImg} alt="equip" w={72} h={72} />
        <Box>
          <Text tt="uppercase" c="var(--text-green)" fw={700} fz={13}>
            {part}
            <Text span inherit tt="capitalize" ml={6} fw={500} c="var(--text-dark)">
              {rarity}
            </Text>
          </Text>
          <Text tt="uppercase" fw={700} fz={13} c="var(--text-dark)">
            {'Rewards'}
            <Text span fz={13} tt="capitalize" ml={6} fw={500} c="var(--text-dark)">
              {rewards}
            </Text>
          </Text>
        </Box>
      </Group>
    </Card>;
};